import React from 'react';
import './SearchBar.css';

function SearchBar({ 
  searchTerm, 
  setSearchTerm, 
  sortBy, 
  setSortBy, 
  totalGames,
  gameTypeFilter,
  setGameTypeFilter,
  themeFilter,
  setThemeFilter,
  availableGameTypes,
  availableThemes
}) {
  return (
    <div className="search-bar">
      <div className="search-container">
        <input
          type="text"
          placeholder="Search games..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="search-input"
        />
        
        <select 
          value={gameTypeFilter} 
          onChange={(e) => setGameTypeFilter(e.target.value)}
          className="filter-select"
        >
          <option value="">All Game Types</option>
          {availableGameTypes.map(type => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>

        <select 
          value={themeFilter} 
          onChange={(e) => setThemeFilter(e.target.value)}
          className="filter-select"
        >
          <option value="">All Themes</option>
          {availableThemes.map(theme => (
            <option key={theme} value={theme}>{theme}</option>
          ))}
        </select>

        <select 
          value={sortBy} 
          onChange={(e) => setSortBy(e.target.value)}
          className="sort-select"
        >
          <option value="name">Sort A-Z</option>
          <option value="name-desc">Sort Z-A</option>
        </select>
      </div>
      <p className="game-count">
        {totalGames === 1 ? '1 game available' : `${totalGames} games available`}
      </p>
    </div>
  );
}

export default SearchBar;
